export const mixin = {
    computed: {
        localizeList() {
            let res = {};
            if (this.$store.getters['getLocalizeList']) {
                res = this.$store.getters['getLocalizeList']
            }
            return res
        },
    },
    methods: {
        hidePopover() {
            this.$store.dispatch("A_HIDE_POPOVER")
        }
    }
};